module.exports = __webpack_public_path__ + "static/media/mongodb.3d40302b.png";